import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

const useAddFunds = ({ onAddFunds, onSaveDefaultFundingAmount, onSuccess, currencyCode }) => {
  const [errors, setErrors] = useAsyncSafeState();
  const purchaseFunds = useCallback(
    async (_useAsDefault, _fundAmount) => {
      setErrors(null);
      const amount = {
        value: Number(_fundAmount),
        code: currencyCode,
      };

      try {
        if (_useAsDefault) {
          await onSaveDefaultFundingAmount(amount);
        }
        await onAddFunds(amount);

        onSuccess(amount);
      } catch (e) {
        setErrors(e?.response?.data?.Errors ?? [{}]);
      }
    },
    [setErrors, currencyCode, onAddFunds, onSuccess, onSaveDefaultFundingAmount],
  );

  return {
    errors,
    purchaseFunds,
  };
};

export default useAddFunds;
